import "./ContactUs.scss";
import Button from "../../components/shared/Button";

import Orbits from "../../assets/images/orbits.svg";
import ContactUsImg from "../../assets/images/contact-us.png";
import RisingEmbers from "../../components/RisingEmbers";

import { ReactComponent as TelegramIcon } from "../../assets/icons/Telegram.svg";
import { ReactComponent as XLogo } from "../../assets/icons/XLogo.svg";

export default function ContactUs() {
	return (
		<>
			<div className="contact-us">
				<div className="decoration contact-us-light-1"></div>

				<div className="contact-us-content-wrapper content-wrapper-lg">
					<div className="contact-us-content">
						<h3 className="contact-us-small-title">Contacts</h3>
						<h2 className="contact-us-title">Get In Touch</h2>
						<p className="contact-us-desc">
							Connect with us to learn more about how AurAI can
							revolutionize your experience in the decentralized
							world. Reach out for our personalized assistance.
						</p>

						<div className="contact-us-btns">
							<Button className="social-btn">
								<TelegramIcon className="social-btn-icon" />
								Telegram
							</Button>
							<Button className="social-btn">
								<XLogo className="social-btn-icon" />X Platform
							</Button>
						</div>
					</div>

					<div className="contact-us-img-wrapper">
						<div className="contact-us-img">
							<div className="embers-wrapper">
								<RisingEmbers
									className="embers"
									width={500}
									height={500}
									emberInterval={200}
								/>
							</div>
							<img className="orbits" src={Orbits} alt="Orbits" />
							<img
								className="crystals"
								src={ContactUsImg}
								alt="Crystals"
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
